import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import CalcIcon from '../../../CalcIcon/CalcIcon';
import { CALC_TYPES } from 'utils/calculatorUtils';
import ReportBlock from './WideBlock';
import ReportBlockMobile from './MobileBlock';
import { useSelectedContext } from 'context/contextSelector';
import { downloadFileFromURL } from 'utils/appUtils';
import { URL_REPORT_RESULT_DETAILS } from 'constants/calculatorsPage';

const ttRestHost = `${process.env.REACT_APP_SSO_API}/tt-documents/docs`;

const ReportResult = ({ targetWidth, assessment, refresh }) => {
  const { user } = useSelectedContext((context) => context.user);
  const navigate = useNavigate();
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (!assessment?.files?.length) return;
    setFile(assessment?.files?.[0]);
  }, [assessment]);

  const onViewClick = () => {
    navigate(`${URL_REPORT_RESULT_DETAILS}/${assessment.type}/${assessment.id}`);
  };

  const downloadFile = (url) => {
    downloadFileFromURL(url, file.originalName);
  };

  const generateLink = () => {
    const token = Cookies.get('access_token');
    const headers = {
      authorization: token ? `Bearer ${token}` : '',
      Userid: user.id,
    };
    const par = `?name=${file.file}`;
    const url = `${ttRestHost}/downloadUrl${par}`;

    axios
      .get(url, { headers })
      .then((response) => {
        const { data } = response;
        if (data?.success) {
          downloadFile(data.url);
        }
      })
      .catch((error) => console.log(error));
  };

  const onMenuClick = (option) => {
    if (option === 'Download') generateLink();
  };

  return (
    <>
      {targetWidth >= 600 && (
        <ReportBlock
          assessment={assessment}
          targetWidth={targetWidth}
          onViewClick={onViewClick}
          onMenuClick={onMenuClick}
          file={file}
        />
      )}
      {targetWidth < 600 && (
        <ReportBlockMobile
          assessment={assessment}
          targetWidth={targetWidth}
          onViewClick={onViewClick}
          onMenuClick={onMenuClick}
          file={file}
          refresh={refresh}
        />
      )}
    </>
  );
};

export default ReportResult;
